// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Jersey from '../_raw/flag/icon_flag_jersey.png';

export default () => <img src={Jersey} alt="Jersey" />;
